import React from "react";
import styled from "@emotion/styled";
import { FormattedMessage } from "react-intl";
import ParkkiTheme from "themes/ParkkiTheme";

const Title = styled.div`
  font-size: ${ParkkiTheme.fontSizes.small};
  font-weight: bolder;
  margin-top: ${ParkkiTheme.spacings.tiny};
  margin-bottom: ${ParkkiTheme.spacings.xsmall};
`;

function ConfigSectorsHeader() {
  return (
    <Title>
      <FormattedMessage id="configSectorsScene.title" />
    </Title>
  );
}

export default ConfigSectorsHeader;
